import React, { useState } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { AddIcon, ApplicationIcon, BtnAddGroupIcon, BtnAddIcon, BtnAddUserIcon, BtnAssignAppIcon, UserIcon } from '../../Icons'
import { useModalContext } from '../../modal/context/ModalProvider';
import { APPLICATION_TAB_TYPE, GROUP_TAB_TYPE, USER_TAB_TYPE } from '../../constant/constants';
import { GROUP_CREATE_PERMISSION, RESOURCE_REVOKE_PERMISSION, USER_CREATE_PERMISSION } from '../../constant/permission';
import { GroupIcon } from '../../assets/Icons';
import { checkPermissionExist } from '../../utils/general';

const { NormalGradientButton } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const AnimatedCreationBtn = ({ currentTab, handleRefreshTab }) => {
    const userData = useUnoSelector((state) => state.user);
    const { openModal } = useModalContext();
    const params = useParams();
    const navigate = useNavigate();
    const [activeState, setActiveState] = useState(false);


    const renderContent = () => {
        switch (currentTab) {
            case USER_TAB_TYPE:
                if (checkPermissionExist(USER_CREATE_PERMISSION)) {
                    return (
                        <NormalGradientButton
                            icon={<UserIcon />}
                            text="User"
                            onClick={() => openModal({ modalName: "USER_ADD", type: "create", id: null, params, handleRefreshTab })}
                        />
                    );
                }
                return null;
            case GROUP_TAB_TYPE:
                if (checkPermissionExist(GROUP_CREATE_PERMISSION)) {
                    return (
                        <NormalGradientButton
                            icon={<GroupIcon />}
                            text="Group"
                            onClick={() => openModal({ modalName: "GROUP_ADD", type: "create", id: null, params, handleRefreshTab })}
                        />
                    );
                }
                return null;
            case APPLICATION_TAB_TYPE:
                if (checkPermissionExist(RESOURCE_REVOKE_PERMISSION)) {
                    return (
                        <NormalGradientButton
                            icon={<ApplicationIcon />}
                            text="Application"
                            onClick={() => navigate(`/resource-management/${userData.user.group.uuid}`)}
                        />
                    );
                }
                return null;
            default:
                <></>;
        }
    };



    return (


        <div className='animated-creation'>
            <div className={`creation-parent ${activeState && "activeNow"}   `}>

                {checkPermissionExist(RESOURCE_REVOKE_PERMISSION) &&
                    <span className=' childBtn' onClick={() => navigate(`/resource-management/${userData.user.group.uuid}`)} >
                        <BtnAssignAppIcon />
                    </span>
                }

                {checkPermissionExist(USER_CREATE_PERMISSION) &&
                    <span className=' childBtn' onClick={() => openModal({ modalName: "USER_ADD", type: "create", id: null, params, handleRefreshTab })}>
                        <BtnAddUserIcon />
                    </span>
                }

                {checkPermissionExist(GROUP_CREATE_PERMISSION) &&
                    <span className=' childBtn' onClick={() => openModal({ modalName: "GROUP_ADD", type: "create", id: null, params, handleRefreshTab })} >
                        <BtnAddGroupIcon />
                    </span>

                }


                <span className={`mainBtn `} onClick={() => setActiveState(!activeState)}>
                    <BtnAddIcon />
                </span>


            </div>
        </div>


    )
}

export default AnimatedCreationBtn